<template>
<div>
  <vs-row>
    <vs-col vs-lg="3" vs-xs="12" v-for="(item,index) in read.slice(0, num)" :key="index">
      <vs-card>
        <div slot="header">
          <span style="font-size: 200%; color: #6eda78">
        {{item.name}}
          </span>
        </div>
        <div style="font-size: 130%">
        Value: {{item.value}} {{item.label}}<br>
        Lastest Update: {{item.time}}
        </div>
      </vs-card>
    </vs-col>
    <!-- <vs-col vs-lg="3" vs-xs="12" v-for="(item,index) in read.slice(31, 34)" :key="index">
      <vs-card>
        <div slot="header">
          <span style="font-size: 150%; text-align: center;">
        {{item.name}}
          </span>
        </div>
        value: {{item.value}} {{item.label}}<br>
        Lastest Update: {{item.time}}
      </vs-card>
    </vs-col> -->
  </vs-row>
<!-- <vs-row vs-justify="flex-end">
  <vs-button type="filled" @click="num += 1" color="secondary" class="ml-4" v-if="read[0]">View More</vs-button>
  <vs-button type="filled" @click="num -= 1" color="secondary" class="ml-4" v-if="read[0]">View Less</vs-button>
</vs-row><br> -->
</div>
</template>
<script>
export default {
  name: "Lastest",
  props: [
    'id',
    'calldata',
    'nwid',
    'type',
    'nwname'
  ],
  data: () => ({
    read: [],
    dataform: {
      data: '',
      date: 0,
    },
    num: 4
  }),
  methods: {
    getLabel(item) {
      if (item.match("Vol")) {
        return "V";
      }
      if (item.match("Cur")) {
        return "A";
      }
      if (item.match("ActivePower")) {
        return "W";
      }
      if (item.match("ReactivePower")) {
        return "Var";
      }
      if (item.match("Apparent")) {
        return "VA";
      }
      if (item.match("Factor")) {
        return "%";
      }
      if (item.match("Freq")) {
        return "Hz";
      }
      if (item.match("impA") || item.match("tedA")) {
        return "Wh";
      }
      if (item.match("impR") || item.match("expR")) {
        return "Varh";
      }
    }
  },
  created() {
    // console.log(this.calldata)
    switch(this.type) {
      case 'powermeter':
        Object.keys(this.calldata[0]).forEach((element,index) => {
          if(element == 'ID' || element == 'Timestamp' || element == 'serial_id' || element == 'Location' || element == 'labels') {}else {
            this.read.push({"name":element,"value":this.calldata[this.calldata.length-1][element],"time":this.$moment(this.calldata[this.calldata.length-1].Timestamp).format('YYYY-MM-DD HH:mm:ss'),"label":this.getLabel(element)})
          }
        });
        break;
      case 'monnit':
        break;
      }
    // switch(this.type) {
    //   case "powermeter":
    //     for(let i = 0;i<this.calldata.length;i++){
    //       this.read[i] = JSON.parse(JSON.stringify(this.calldata[i]));
    //     }
    //     break;
    //     case "monnit":
    //     for(let i = 0;i<this.calldata.length;i++){
    //       this.read[i] = JSON.parse(JSON.stringify(this.calldata[i]));
    //     }
    //     break;
    // }
  }
};
</script>
<style scoped>
.wrapper.overflow {
  overflow-y: scroll;
  max-height: 250px;
  
}
</style>
